import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { categoriesToOptionsConverter } from '../../../../Tables/Settings/DutyHourTypes/components/utils/categoriesToOptionsConverter';

import {
  getAdminReports,
  getAdvancedReports,
  getBalancedReports,
  getBasicReports,
  getServiceDeskReports
} from 'RestAPIs/admin';

import {
  ADMIN_REPORTS,
  ADVANCED_REPORTS,
  BALANCE_REPORTS,
  BASE_REPORTS,
  BaseType,
  SERVICEDESK_REPORTS
} from '../../type';
import {
  converterForPlanningReports,
  parsedObject
} from '../converterForReports';
import axios from 'axios';

type ReportTypes =
  | typeof BASE_REPORTS
  | typeof ADVANCED_REPORTS
  | typeof ADMIN_REPORTS
  | typeof BALANCE_REPORTS
  | typeof SERVICEDESK_REPORTS;

export const getReport = async ({
  reportTypes,
  requestParameters,
  baseType
}) => {
  const convertedParams = converterForPlanningReports(requestParameters);

  return axios.get(
    `secure/users/{username}/reports/${baseType}/${reportTypes}`,
    {
      ...(convertedParams ? { params: parsedObject(convertedParams) } : {})
    }
  );
};

export const useGetAccessedReports = (hasAccess) => {
  return useQuery({
    enabled: hasAccess,
    queryKey: ['basic'],
    initialData: [],
    queryFn: async () =>
      await getBasicReports().then(
        categoriesToOptionsConverter({
          getLabel: (option) => option.label,
          getValue: (option) => option.name,
          sortBy: 'label'
        })
      )
  });
};

export const useGetAdvancedReports = (hasAccess) => {
  return useQuery({
    enabled: hasAccess,
    queryKey: ['advanced'],
    initialData: [],
    queryFn: async () =>
      await getAdvancedReports().then(
        categoriesToOptionsConverter({
          getLabel: (option) => option.label,
          getValue: (option) => option.name,
          sortBy: 'label'
        })
      )
  });
};

export const useGetAdminReports = (hasAccess) => {
  return useQuery({
    enabled: hasAccess,
    queryKey: ['admin'],
    initialData: [],
    queryFn: async () =>
      getAdminReports().then(
        categoriesToOptionsConverter({
          getLabel: (option) => option.label,
          getValue: (option) => option.name,
          sortBy: 'label'
        })
      )
  });
};

export const useGetBalanceReports = (hasAccess) => {
  return useQuery({
    enabled: hasAccess,
    queryKey: ['balance'],
    initialData: [],
    queryFn: async () =>
      await getBalancedReports().then(
        categoriesToOptionsConverter({
          getLabel: (option) => option.label,
          getValue: (option) => option.name,
          sortBy: 'label'
        })
      )
  });
};

export const useGetServiceDeskReports = (hasAccess) => {
  return useQuery({
    enabled: hasAccess,
    queryKey: ['servicedesk'],
    initialData: [],
    queryFn: async () =>
      await getServiceDeskReports().then(
        categoriesToOptionsConverter({
          getLabel: (option) => option.label,
          getValue: (option) => option.name,
          sortBy: 'label'
        })
      )
  });
};

export const useHandleMultipleEndpointForReportSelection = (reportTypes) => {
  const [baseType, setBaseType] = useState<BaseType | ''>('');

  const getBaseType = (type: ReportTypes) =>
    Object.values(type).includes(reportTypes) ? reportTypes : undefined;

  useEffect(() => {
    switch (reportTypes) {
      case getBaseType(BASE_REPORTS):
        setBaseType('basic');
        break;
      case getBaseType(ADMIN_REPORTS):
        setBaseType('admin');
        break;
      case getBaseType(ADVANCED_REPORTS):
        setBaseType('advanced');
        break;
      case getBaseType(BALANCE_REPORTS):
        setBaseType('balance');
        break;
      case getBaseType(SERVICEDESK_REPORTS):
        setBaseType('servicedesk');
        break;
      default:
        break;
    }
  }, [reportTypes]);

  return baseType;
};
